export default {"src":"/_next/static/media/shareholder_guide_3.b7eb2567.svg","height":424,"width":816,"blurWidth":0,"blurHeight":0};